<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('NAME')">
          <b-form-input  type="text" :value="user.name" :disabled="true"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" lg="4">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input  type="email" :value="user.email" :disabled="true"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('CHANGE_PASSWORD')">
          <b-form-input type="password" v-model="password"></b-form-input>
          <validation-description :show="$v.password.$dirty && $v.password.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('REPEAT_PASSWORD')">
          <b-form-input type="password" v-model="repeat_password"></b-form-input>
          <validation-description :show="$v.repeat_password.$dirty && $v.repeat_password.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {C_USER_SAVE_BUTTON} from '@/shared/component_permission'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {required} from "vuelidate/lib/validators";
    export default {
      name: "user-basic-form",
      mixins: [getErrorMessage],
      data() {
        return{
          password:'',
          repeat_password:'',
          disabled: true,
          loading:false,
          C_USER_SAVE_BUTTON
        }
      },
      validations:{
        password:{required},
        repeat_password:{required},
      },
      components: {
        AppButtonSubmit, DatePicker, ValidationDescription
      },
      computed: {
        languages() {
          return Object.keys(this.$i18n.messages)
        },
        user() {
          return this.$store.getters['user/getUser']
        },
      },
      methods:{
        submit() {
          this.$v.$touch()
          if(this.$v.$invalid){
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 6000
            })
            return
          }
          if(this.password != this.repeat_password) {
            toast({
              'title': this.$t('PASSWORD_DO_NOT_MATCH'),
              'message': null,
              'type': 'error',
              'timeout': 6000
            })
            return
          }
          let data = {
            password: this.password,
          }
          this.$store.dispatch('user/actionUpdateUser', {id: this.user.id, data }).then(() => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                type: 'success',
                timeout: 3000
              })
            },
            error => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                type: 'error',
                timeout: 6000
              })
            })
        }
      }
    }
</script>

<style scoped>

</style>
